import { render } from "./ServiceSearch.vue?vue&type=template&id=47f24852"
import script from "./ServiceSearch.vue?vue&type=script&lang=js"
export * from "./ServiceSearch.vue?vue&type=script&lang=js"

import "@/assets/style/table.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__